export default __webpack_public_path__ + "static/media/plagueswarm.9ff136db.png";